var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackSubmittedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "#c7222a "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9306 57.3507L37.5446 49.03L32.9336 53.6051L44 64.5855L44.0127 64.5728L46.033 66.5774L71.733 41.0641L67.0326 36.4L45.9306 57.3507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSubmittedicon);
export default __webpack_public_path__ + "static/media/feedback_submittedicon.ff70ea796a0f9cbd71541e4803c729f2.svg";
export { ForwardRef as ReactComponent };